/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const TurnDownRightSolidV6 = (props) => (
  <Icon {...props} name="Turn Down Right Solid V6">
    <path d="M11.45 12.937a.754.754 0 0 1-.45-.687V9.972H2.5a2.485 2.485 0 0 1-2.5-2.5V2a1 1 0 1 1 2 0v5.472c0 .303.225.5.5.5H11V5.75c0-.297.178-.569.45-.688a.746.746 0 0 1 .809.138l3.5 3.25a.747.747 0 0 1 0 1.1l-3.5 3.25a.748.748 0 0 1-.809.137z" />
  </Icon>
);

export default TurnDownRightSolidV6;
